module.exports = __webpack_public_path__ + "balboa-w01-bold.ttf";